module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_palace_e30d5de.png";